export default __webpack_public_path__ + "static/media/March_09.6ded465e.png";